<template>
  <div class="container">
    <CRow alignHorizontal="end" alignVertical="center">
      <div
        class="containerIconClose"
        @click="funcRoute(cardContent.navigate.close.action)"
      >
        <font-awesome-icon icon="times" class="IconClose" />
      </div>
    </CRow>

    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow
          alignHorizontal="between"
          alignVertical="center"
          class="mr-2 ml-2"
        >
          <h3 :class="checkLangClass() + ' ' + 'm-2'">
            {{ checkLanguage(cardContent.title) }} :
            {{ checkLanguage(cardContent.description) }}
          </h3>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow align-vertical="center" align-horizontal="center" class="mb-3">
          <h1 :class="checkLangClass() + ' ' + 'header-text'">
            {{ checkLanguage(cardContent.content.title) }}
          </h1>
        </CRow>
        <CRow
          v-if="screenSize > 500"
          align-vertical="center"
          align-horizontal="center"
          class="mr-5 ml-5 desc"
        >
          <p :class="checkLangClass() + ' ' + 'mb-3 content-text'">
            {{ checkLanguage(cardContent.content.description) }}
          </p>
        </CRow>
        <CRow
          v-if="screenSize <= 500"
          align-vertical="center"
          align-horizontal="center"
          class="mr-2 ml-2 desc"
        >
          <p :class="checkLangClass() + ' ' + 'mb-3 content-text'">
            {{ checkLanguage(cardContent.content.description) }}
          </p>
        </CRow>
        <CRow align-vertical="center" align-horizontal="center">
          <CButton
            color="danger"
            shape="pill"
            size="lg"
            class="ml-2 mr-2 mt-5 pl-4 pr-4 pt-2 pb-2"
            @click="funcBackRoute(cardContent.navigate.previous.action)"
            >{{ checkLanguage(cardContent.navigate.previous.title) }}</CButton
          >
          <CButton
            color="success"
            shape="pill"
            size="lg"
            class="ml-2 mr-2 mt-5 pl-4 pr-4 pt-2 pb-2"
            @click="funcRoute(cardContent.navigate.next.action)"
            >{{ checkLanguage(cardContent.navigate.next.title) }}</CButton
          >
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import '../../../../assets/scss/_chineseStyle.scss';
import '../../../../assets/scss/_chineseIcon.scss';

export default {
  name: 'CardIntro',
  components: {},
  props: {
    cardContent: Object,
    nextTo: Function,
    prevTo: Function,
  },
  data() {
    return {
      lang: '',
      screenSize: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
    }),
  },

  watch: {
    storeLanguage: function (val) {
      this.lang = val;
    },
  },
  created() {
    this.lang = this.$store.state.language.language;
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
        console.log('change language is error!!');
      }
    },
    funcRoute(tempId) {
      const path = tempId.split('-');
      if (tempId === 'PreTest') {
        alert('You cannot exit while doing pretests.');
      } else {
        this.$emit('funcRoute', path);
      }
    },
    funcBackRoute(tempId) {
      const path = tempId.split('-');
      const previousPath = `/v3/${path[0]}/${path[1]}`;

      if (tempId == 'PreTest') {
        alert('You cannot exit while doing pretests.');
      } else {
        this.$router.push(previousPath);
      }
    },
  },
};
</script>
<style>
.desc {
  text-align: center !important;
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .header-text {
    font-size: 40px;
  }
}
</style>
